<div class="container">
  <div class="row">
    <div class="col col-12" style="flex-basis: max-content; margin: auto;">
      <ngx-charts-pie-chart [view]="[120,120]" [scheme]="greenRedPalette" [results]="completed" [legend]="false"
        [explodeSlices]="false" [labels]="false" [doughnut]="true" [gradient]="false">
      </ngx-charts-pie-chart>
    </div>
    <div class="col col-12 text-center">
      <span class="h1 font-weight-bold text-primary" style="font-size:2.0vw;">{{completedAudits | number: '1.0-0'}}%</span>
    </div>
    <div class="col col-12 text-center">
      <span class="text-primary">Audits Completed</span>
    </div>
  </div>
</div>
